import type { ReactElement } from 'react';
import { clsx } from 'clsx';

type TooltipProps = {
  label: string;
  children: ReactElement;
  align?: 'center' | 'end';
};

export function Tooltip({ label, children, align = 'center' }: TooltipProps) {
  const tooltipAlignClass =
    align === 'end'
      ? 'right-0 translate-x-0'
      : 'left-1/2 -translate-x-1/2';
  const arrowAlignClass =
    align === 'end' ? 'right-2 translate-x-0' : 'left-1/2 -translate-x-1/2';

  return (
    <span className="group relative inline-flex">
      {children}
      <span
        role="tooltip"
        className={clsx(
          'pointer-events-none absolute bottom-full z-10 mb-2 whitespace-nowrap rounded bg-unilink-text-primary px-3 py-2 text-xs leading-4 text-white opacity-0 transition-opacity group-hover:opacity-100 group-focus-within:opacity-100',
          tooltipAlignClass
        )}
      >
        {label}
        <span
          aria-hidden
          className={clsx(
            'absolute top-full border-[6px] border-transparent border-t-unilink-text-primary',
            arrowAlignClass
          )}
        />
      </span>
    </span>
  );
}
